import { render, staticRenderFns } from "./TableRules.vue?vue&type=template&id=3ed63a6c&scoped=true"
import script from "./TableRules.vue?vue&type=script&lang=js"
export * from "./TableRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed63a6c",
  null
  
)

export default component.exports